import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { FaSave } from 'react-icons/fa';
import horarioService from '../services/horarioService';
import PageHeader from './PageHeader';
import SkeletonLoader from './SkeletonLoader'; // <-- Importado
import styles from './HorariosManager.module.css';

const diasDaSemana = [
  { id: 1, nome: 'Segunda' }, { id: 2, nome: 'Terça' },
  { id: 3, nome: 'Quarta' }, { id: 4, nome: 'Quinta' },
  { id: 5, nome: 'Sexta' }, { id: 6, nome: 'Sábado' },
  { id: 0, nome: 'Domingo' }
];

const HorariosManager = () => {
  const [horarios, setHorarios] = useState({});
  const [loading, setLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const fetchHorarios = async () => {
      setLoading(true);
      try {
        const data = await horarioService.getHorarios();
        const horariosPorDia = data.reduce((acc, h) => {
          acc[h.dia_da_semana] = { hora_inicio: h.hora_inicio, hora_fim: h.hora_fim, ativo: true };
          return acc;
        }, {});
        setHorarios(horariosPorDia);
      } catch (error) {
        toast.error("Não foi possível carregar seus horários.");
      } finally {
        setLoading(false);
      }
    };
    fetchHorarios();
  }, []);

  const handleHorarioChange = (diaId, campo, valor) => {
    setHorarios(prev => ({
      ...prev,
      [diaId]: { ...prev[diaId], [campo]: valor }
    }));
  };

  const handleAtivoChange = (diaId, isAtivo) => {
    const horarioPadrao = { hora_inicio: '09:00:00', hora_fim: '18:00:00' };
    setHorarios(prev => ({
      ...prev,
      [diaId]: { ...prev[diaId], ...horarioPadrao, ativo: isAtivo }
    }));
  };
  
  const handleSaveChanges = () => {
    setIsSaving(true);
    const horariosParaSalvar = Object.entries(horarios)
      .filter(([_, h]) => h.ativo && h.hora_inicio && h.hora_fim)
      .map(([dia, h]) => ({
        dia_da_semana: parseInt(dia),
        hora_inicio: h.hora_inicio,
        hora_fim: h.hora_fim
      }));
      
    toast.promise(
      horarioService.setHorarios(horariosParaSalvar),
      {
        loading: 'Salvando alterações...',
        success: 'Horários salvos com sucesso!',
        error: 'Falha ao salvar horários.',
      }
    ).finally(() => setIsSaving(false));
  };

  // Alteração aqui para usar o Skeleton
  if (loading) {
    return (
      <div className="page-container">
        <PageHeader title="Meus Horários de Trabalho" />
        <div className="card">
          <SkeletonLoader type="card" />
          <SkeletonLoader type="card" />
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <PageHeader title="Meus Horários de Trabalho" />

      {/* Usamos a classe global .card e a classe local .horariosContainer */}
      <div className={`card ${styles.horariosContainer}`}>
        <p>Marque os dias que você trabalha e defina seus horários de início e fim.</p>
        
        <div className={styles.horariosGrid}>
          {diasDaSemana.map(dia => {
            const horarioDoDia = horarios[dia.id] || { ativo: false };
            return (
              // Note como as classes agora vêm do objeto 'styles'
              <div key={dia.id} className={`${styles.diaCard} ${!horarioDoDia.ativo ? styles.inativo : ''}`}>
                <div className={styles.diaHeader}>
                  <strong>{dia.nome}-feira</strong>
                  <label className={styles.switch}>
                    <input type="checkbox" checked={horarioDoDia.ativo} onChange={(e) => handleAtivoChange(dia.id, e.target.checked)} />
                    <span className={`${styles.slider} ${styles.round}`}></span>
                  </label>
                </div>
                {horarioDoDia.ativo && (
                  <div className={styles.horarioDetails}>
                    <div className={styles.horarioInputsWrapper}>
                      <div className="input-group"> {/* Classe global do index.css */}
                        <label>Início</label>
                        <input type="time" className="form-input" value={horarioDoDia.hora_inicio || '09:00'} onChange={(e) => handleHorarioChange(dia.id, 'hora_inicio', e.target.value)} />
                      </div>
                      <div className="input-group">
                        <label>Fim</label>
                        <input type="time" className="form-input" value={horarioDoDia.hora_fim || '18:00'} onChange={(e) => handleHorarioChange(dia.id, 'hora_fim', e.target.value)} />
                      </div>
                    </div>
                  </div>
                )}
                 {!horarioDoDia.ativo && (
                  <div className={styles.folgaText}>Folga</div>
                )}
              </div>
            );
          })}
        </div>
        <div className={styles.saveButtonContainer}>
          <button onClick={handleSaveChanges} className="btn btn-primary" disabled={isSaving}>
            <FaSave /> {isSaving ? 'Salvando...' : 'Salvar Alterações'}
          </button>
        </div>
      </div>
    </div>
  );
};
// Lembre-se de adicionar a lógica de fetch e as funções handle que omiti por brevidade
export default HorariosManager;